// ============================================================
// 隐私政策页（公开访问，无需登录 — Waffo 审核要求）
// 结构对齐 Waffo Pancake 隐私政策模板（12 节）
// ============================================================

import LegalPage, { type LegalSection } from '../components/LegalPage';

const sections: LegalSection[] = [
  {
    title: 'legal.privacy.s1.title',
    paragraphs: ['legal.privacy.s1.p1', 'legal.privacy.s1.p2'],
  },
  {
    title: 'legal.privacy.s2.title',
    paragraphs: [
      'legal.privacy.s2.p1',
      'legal.privacy.s2.p2',
      'legal.privacy.s2.p3',
    ],
  },
  {
    title: 'legal.privacy.s3.title',
    paragraphs: [
      'legal.privacy.s3.p1',
      'legal.privacy.s3.p2',
      'legal.privacy.s3.p3',
    ],
  },
  {
    title: 'legal.privacy.s4.title',
    paragraphs: ['legal.privacy.s4.p1'],
  },
  {
    title: 'legal.privacy.s5.title',
    paragraphs: [
      'legal.privacy.s5.p1',
      'legal.privacy.s5.p2',
      'legal.privacy.s5.p3',
    ],
  },
  {
    title: 'legal.privacy.s6.title',
    paragraphs: ['legal.privacy.s6.p1', 'legal.privacy.s6.p2'],
  },
  {
    title: 'legal.privacy.s7.title',
    paragraphs: ['legal.privacy.s7.p1', 'legal.privacy.s7.p2'],
  },
  {
    title: 'legal.privacy.s8.title',
    paragraphs: ['legal.privacy.s8.p1', 'legal.privacy.s8.p2'],
  },
  {
    title: 'legal.privacy.s9.title',
    paragraphs: ['legal.privacy.s9.p1'],
  },
  {
    title: 'legal.privacy.s10.title',
    paragraphs: ['legal.privacy.s10.p1'],
  },
  {
    title: 'legal.privacy.s11.title',
    paragraphs: ['legal.privacy.s11.p1'],
  },
  {
    title: 'legal.privacy.s12.title',
    paragraphs: ['legal.privacy.s12.p1'],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      title="legal.privacy.title"
      updated="legal.privacy.updated"
      intro="legal.privacy.intro"
      sections={sections}
    />
  );
}
